var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{class:_vm.$options.expandClass,attrs:{"aria-controls":"super-sidebar","aria-expanded":"false","aria-label":_vm.$options.i18n.openNavigationMenu,"icon":"hamburger","data-testid":"super-sidebar-toggle-button","category":"tertiary"},on:{"click":_vm.openSidebar}})
}
var staticRenderFns = []

export { render, staticRenderFns }